import {GetExamsBooked, GetExamsBookedParams, GetExamsBookedModel} from 'domain/usecases';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';

export class RemoteGetExamsBooked implements GetExamsBooked {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetExamsBookedModel>,
	) {}

	async get({signal, ...params}: GetExamsBookedParams): Promise<GetExamsBookedModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
